import { ICalculatorState } from '../../subsidizedCalculator/types/calculator';

type TDetail = { description: string; calculatorValues: ICalculatorState };
/**
 * @dispatchCustomEvent
 * @param eventTarget html элемент
 * @param eventName название события
 * @param detail объект для передачи в событии
 * @return void
 */
export function dispatchCustomEvent(eventTarget: EventTarget, eventName: string, detail: TDetail) {
  eventTarget.dispatchEvent(
    new CustomEvent(eventName, {
      bubbles: true,
      cancelable: false,
      detail,
    }),
  );
}
